// src/components/FloatingCartButton.js
import React from "react";
import { Fab, Badge } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";

const FloatingCartButton = ({
  getCartItemCount,
  setCartDrawerOpen,
  primaryBlue,
  glassStyles,
}) => {
  return (
    <Fab
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
        ...glassStyles,
        bgcolor: "rgba(0, 114, 206, 0.9)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        "&:hover": {
          bgcolor: "rgba(11, 28, 72, 0.9)",
          transform: "scale(1.1)",
          boxShadow: "0 12px 40px rgba(0, 114, 206, 0.4)",
        },
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
      onClick={() => setCartDrawerOpen(true)}
    >
      <Badge
        badgeContent={getCartItemCount()}
        color="error"
        sx={{
          "& .MuiBadge-badge": {
            background: "linear-gradient(45deg, #ff6b6b, #ee5a52)",
            color: "white",
            fontWeight: "bold",
            border: "2px solid white",
          },
        }}
      >
        <ShoppingCart />
      </Badge>
    </Fab>
  );
};

export default FloatingCartButton;
